<bb-card-loading *ngIf="loading"></bb-card-loading>
<p-chart *ngIf="!loading && !!chart" type="bar" [data]="chart" [options]="chartOptions"></p-chart>

<ion-item *ngIf="!loading && !chart && !error">
    No data.
</ion-item>

<ion-item *ngIf="!loading && error">
    <ion-text color="danger">Could not load data.</ion-text>
</ion-item>
